/** @format */
import React from "react";
import "./batches.css";
import { TableLoader } from "../../components/loader/Resusable/Table";
import dropDown from "../../../assets/img/dropDown-long_icon.svg";
import dropDownActive from "../../../assets/img/dropDown-long_icon_active.svg";
import dropUpActive from "../../../assets/img/dropDown-long_icon_up_active.svg";
import noData from "../../../assets/img/noData.svg";

export const UsersTable = ({
  thead,
  tbody,
  loading,
  sortBy,
  order,
  setFilter,
}) => {
  return loading ? (
    <TableLoader columns={thead.length} />
  ) : (
    <table
      width="100%"
      cellSpacing="0"
      className="table batchTable intableCheckbox"
    >
      <thead className="pad-topp">
        <tr className="batchesHeader">
          <th className="table_header">
            User Name
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "first_name"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "first_name",
                    sortBy === "first_name"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
          <th className="table_header">
            User Email
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "email"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "email",
                    sortBy === "email"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
          <th className="table_header">
            Created On
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "created_at"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "created_at",
                    sortBy === "created_at"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {tbody && tbody.length ? (
          tbody.map((th, index) => (
            <tr key={index} className="btachRow history">
              <td>
                <span className="textContol">
                  {[th.first_name, th.last_name].filter(Boolean).join(" ")}
                </span>
              </td>
              <td>
                <span className="textContol">{th.email}</span>
              </td>
              <td>
                <span className="textContol">
                  {`${th.created_atDate} | ${th.created_atTime}`}
                </span>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={thead.length}
              className="text-center image-no-data-sm nodataTablePosition"
              // style={{ paddingTop: "150px" }}
            >
              <>
                <img style={{ width: "110px" }} src={noData} alt="" />
                <p>The data you're looking is not available at this moment</p>
              </>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
